import _mapValues from "lodash-es/mapValues";
export var SalesItemTypes = /*#__PURE__*/function (SalesItemTypes) {
  SalesItemTypes["Membership"] = "MEMBERSHIP";
  SalesItemTypes["PrepaidCard"] = "PREPAID";
  SalesItemTypes["Subscription"] = "SUBSCRIPTION";
  SalesItemTypes["WashPackage"] = "WASHPACKAGE";
  return SalesItemTypes;
}(SalesItemTypes || {});
export const WashPackageSKUs = Object.freeze(["WP-BASIC", "WP-CLEAN", "WP-SHINE", "WP-PROTECT", "WP-BEST"]);
export const AutoPayMembershipSKUs = Object.freeze(["SUB-MB-B-030", "SUB-MB-C-030", "SUB-MB-S-030", "SUB-MB-P-030", "SUB-MB-T-030"]);
export const AvailableAutoPayMembershipSKUs = Object.freeze(["SUB-MB-S-030", "SUB-MB-P-030", "SUB-MB-T-030"]);
export const DayPassSKUs = Object.freeze(_mapValues({
  30: ["MB-B-030", "MB-C-030", "MB-S-030", "MB-P-030", "MB-T-030"],
  60: ["MB-B-060", "MB-C-060", "MB-S-060", "MB-P-060", "MB-T-060"],
  90: ["MB-B-090", "MB-C-090", "MB-S-090", "MB-P-090", "MB-T-090"],
  180: ["MB-B-180", "MB-C-180", "MB-S-180", "MB-P-180", "MB-T-180"],
  365: ["MB-B-365", "MB-C-365", "MB-S-365", "MB-P-365", "MB-T-365"]
}, array => Object.freeze(array)));
export const FlockAddonSKUs = Object.freeze(["SUB-FLOCK-MB-B-030", "SUB-FLOCK-MB-C-030", "SUB-FLOCK-MB-S-030", "SUB-FLOCK-MB-P-030", "SUB-FLOCK-MB-T-030"]);
export const FLOCK_SKU_PREFIX = /^SUB-FLOCK/;
export const PrepaidDayCardSKUs = Object.freeze(_mapValues({
  30: ["PP-30-DAY-GOOD", "PP-30-DAY-BETTER", "PP-30-DAY-LUCKYDUCK"],
  365: ["PP-365-DAY-GOOD", "PP-365-DAY-BETTER", "PP-365-DAY-LUCKYDUCK"]
}, array => Object.freeze(array)));
export const PrepaidWashCardSKUs = Object.freeze(_mapValues({
  1: ["PP-1-WASH-GOOD", "PP-1-WASH-BETTER", "PP-1-WASH-LUCKYDUCK"],
  5: ["PP-5-WASH-GOOD", "PP-5-WASH-BETTER", "PP-5-WASH-LUCKYDUCK"],
  10: ["PP-10-WASH-GOOD", "PP-10-WASH-BETTER", "PP-10-WASH-LUCKYDUCK"],
  25: ["PP-25-WASH-GOOD", "PP-25-WASH-BETTER", "PP-25-WASH-LUCKYDUCK"],
  100: ["PP-100-WASH-GOOD", "PP-100-WASH-BETTER", "PP-100-WASH-LUCKYDUCK"]
}, array => Object.freeze(array)));
export const PREPAID_DAY_CARD_SKU_PREFIX = /^PP-\d+-DAY/;
export const PREPAID_WASH_CARD_SKU_PREFIX = /^PP-\d+-WASH/;
